var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsightEngineGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.3,
    d: "M15.8334 4.16663H4.16675V15.8333H15.8334V4.16663Z",
    fill: "url(#paint0_linear_1058_1289)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.8333 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM15.8333 15.8333H4.16667V4.16667H15.8333V15.8333Z",
    fill: "url(#paint1_linear_1058_1289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.49992 10H5.83325V14.1667H7.49992V10Z",
    fill: "url(#paint2_linear_1058_1289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.1667 5.83337H12.5V14.1667H14.1667V5.83337Z",
    fill: "url(#paint3_linear_1058_1289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.8334 11.6666H9.16675V14.1666H10.8334V11.6666Z",
    fill: "url(#paint4_linear_1058_1289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.8334 8.33337H9.16675V10H10.8334V8.33337Z",
    fill: "url(#paint5_linear_1058_1289)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1058_1289",
    x1: 4.64323,
    y1: 9.99996,
    x2: 15.3136,
    y2: 9.99996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1058_1289",
    x1: 3.11262,
    y1: 10,
    x2: 16.8317,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1058_1289",
    x1: 5.90132,
    y1: 12.0833,
    x2: 7.42566,
    y2: 12.0833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1058_1289",
    x1: 12.5681,
    y1: 10,
    x2: 14.0924,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1058_1289",
    x1: 9.23482,
    y1: 12.9166,
    x2: 10.7592,
    y2: 12.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1058_1289",
    x1: 9.23482,
    y1: 9.16671,
    x2: 10.7592,
    y2: 9.16671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66D1FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightEngineGreen);
export default __webpack_public_path__ + "static/media/InsightEngine-green.d2cc1a7561c0235f0507f8e20b26588c.svg";
export { ForwardRef as ReactComponent };